import BasicProduction from "@/views/open_queries/agroexporter/BasicProduction.vue";

export default [
  {
    path: "/oq/agroexporter/basic_production/:agroexporter_id",
    name: "oq_agroexporter_basic_production_path",
    component: BasicProduction,
    props: true
  }
];
